<!-- Native-Angular port of account-v1/.../people/details/details.html.
     Renders the BODY of the guest-detail modal; outer ftModal shell stays
     AngularJS (account-v2 details.component owns it). Keeps the exact DOM
     structure of the AngularJS template so pixel-parity holds against the
     frozen baseline. AngularJS filter ports used: parse / dateFormat /
     fullName / translate (via $translate) / activityType — all in
     PeopleModule. `ft-targets-modal`, `ft-start-task`, `ft-disable-while-
     task-pending` and the inline sub-modals are no-op placeholders here
     (the unported ftModal directive owns the sub-modal lifecycle). -->
<section class="ft-section ft-person-profile-section" [hidden]="isLoading()">
    @if (advocate()) {
        <div class="ft-container">
            <div class="chloro-map"></div>
            <!-- Info -->
            <div class="ft-person-info">
                <ft-guest-photo [src]="advocate().profileImageUrl" [silhouetteClass]="advocate().silhouetteClass" />
                @if (advocate().lastActivityType) {
                    <p>
                        <span class="ft-label">{{'flipto.account.MostRecentActivity' | translate}}</span>
                        <br />
                        <span class="ft-summary">{{advocate().lastActivityType | activityType}}</span>
                    </p>
                }
                @if (advocate().reservationNumber && isPiiInfoVisible()) {
                    <p>
                        <span class="ft-label">{{'flipto.account.Reservation' | translate}}</span>
                        <br />
                        <span class="ft-summary ft-count">{{advocate().reservationNumber}}</span>
                    </p>
                }
                @if (isHotelStayAvailable() && advocate().epochStartDate > 0) {
                    <p>
                        <span class="ft-label">{{'flipto.account.StayDates' | translate}}</span>
                        <br />
                        <span class="ft-summary ft-count">
                            {{advocate().epochStartDate | parse: 'number' | dateFormat: 'MMM D'}} - {{advocate().epochEndDate | parse: 'number' | dateFormat: 'MMM D'}}, {{advocate().epochEndDate | parse: 'number' | dateFormat: 'YYYY'}}
                        </span>
                    </p>
                }
                @if (advocate().epochCancelDate > 0) {
                    <p>
                        <span class="ft-label">{{'flipto.account.Cancelled' | translate}}</span>
                        <br />
                        <span class="ft-summary ft-count">
                            {{advocate().epochCancelDate | parse: 'number' | dateFormat: 'MMM D YYYY'}}
                        </span>
                    </p>
                }
            </div>

            <!-- Contact -->
            @if (isPiiInfoVisible()) {
                <div class="ft-person-contact">
                    <p>{{advocate() | fullName}}</p>
                    <p>
                        @if (advocate().email) {
                            <a [href]="'mailto: ' + advocate().email">
                                <span class="icon">
                                    <img src="v1-assets/img/icons/layers/icon-email-advocate.png" />
                                </span>
                                {{advocate().email}}
                            </a>
                        }
                    </p>
                    <p>
                        @if (advocate().twitter) {
                            <a [href]="'//twitter.com/' + advocate().twitter" target="_blank">
                                <span class="icon">
                                    <img src="v1-assets/img/icons/layers/icon-tw-advocate.png" />
                                </span>
                                &#64;{{advocate().twitter}}
                            </a>
                        }
                    </p>
                </div>
            }

            <!-- Edit profile -->
            @if (identity.hasPiiPermissions()) {
                <div class="ft-person-edit">
                    @if (!isPiiInfoVisible()) {
                        <button type="button" class="ft-btn ft-btn-outline-dark"
                                (click)="showPiiInfo()">
                            <i class="fa fa-eye"></i>&nbsp;&nbsp;@if (advocate().first) {<span>{{'flipto.account.ShowInfo' | translate: { first: advocate().first } }}</span>} @else {<span>{{'flipto.account.ShowInfoNoName' | translate}}</span>}
                        </button>
                    }
                    @if (isPiiInfoVisible()) {
                        <button type="button" class="ft-btn ft-btn-outline-dark" (click)="editOpen.set(true)">
                            <i class="fa fa-pencil"></i>&nbsp;&nbsp;<span>{{'flipto.account.people.details.EditDetails' | translate}}</span>
                        </button>
                    }
                    <button id="removeButton" type="button" class="ft-btn ft-btn-outline-dark" (click)="removeOpen.set(true)">
                        <i class="fa fa-trash"></i>&nbsp;&nbsp;
                        <span>{{'flipto.account.people.details.RemoveDetails' | translate}}</span>
                    </button>
                    <a class="ft-btn ft-btn-outline-dark"
                        style="text-align: left; padding-left: 1em;"
                        [href]="'//' + environment.FliptoPlatformDomain + '/email/subscribe?co=' + advocate().companyCode + '&id=' + advocate().guestUUID + '&type=1'"
                        target="_blank">
                        <i class="fa fa-external-link"></i>&nbsp;&nbsp;
                        <span>Unsubscribe page</span>
                    </a>
                </div>
            }

            <!-- v1 people.details.guestInfo edit modal (port) -->
            <ft-edit-guest-details-ng [advocate]="advocate()" [(open)]="editOpen" (saved)="onGuestSaved($event)" />
            <!-- v1 people.details.cancelReservation modal (port) -->
            <ft-remove-guest-details-ng [advocate]="advocate()" [(open)]="removeOpen" />
            <!-- v1 advocateEditCertificateExpirationDate modal (port) -->
            @if (selectedIncentive) {
                <ft-modal-overlay [open]="expirationOpen()">
                    @if (expirationOpen()) {
                        <ft-modal-chrome-ng
                            [headerText]="'flipto.account.settings.incentives.ExpirationDate' | translate"
                            size="sm"
                            [doneVisible]="true"
                            [cancelVisible]="true"
                            [footerVisible]="true"
                            [footerCancelVisible]="false"
                            (done)="saveCertificateExpirationDate()"
                            (cancel)="expirationOpen.set(false)"
                        >
                            <div class="modal-panel">
                                <ft-date-picker-ng [(date)]="selectedIncentive.utcExpirationDate" position="left" />
                            </div>
                        </ft-modal-chrome-ng>
                    }
                </ft-modal-overlay>
            }

            @if (identity.isFliptoStaff() && !!advocate().prestay && !!advocate().prestay.promotions.length && !advocate().prestay.incentives.length) {
                <div class="ft-row" style="margin-top: 0.5em;">
                    <div class="ft-col-35 action-container">
                        <input type="button" value="Request Promotion Certificate" class="ft-btn ft-btn-outline-dark" (click)="requestPromotionCertificate()">
                    </div>
                </div>
            }

            <!-- Stats -->
            <div class="ft-person-stats">
                <div class="ft-row">
                    <div class="ft-col-33">
                        <img src="v1-assets/img/icons/layers/icon-advocate-connections.png" />
                        <span class="ft-count">{{(advocate().totalFollowers || advocate().totalVisitors) | number}}</span>
                        <span class="ft-count-label">{{'flipto.account.platform.SocialConnections' | translate}}</span>
                    </div>
                    <div class="ft-col-33">
                        <img src="v1-assets/img/icons/layers/icon-advocate-visitors.png" />
                        <span class="ft-count">{{advocate().totalVisitors | number}}</span>
                        <span class="ft-count-label">{{'flipto.account.platform.UniqueVisitors' | translate}}</span>
                    </div>
                    <div class="ft-col-33">
                        <img src="v1-assets/img/icons/layers/icon-advocate-signups.png" />
                        <span class="ft-count">{{advocate().totalSignups | number}}</span>
                        <span class="ft-count-label">{{'flipto.account.platform.WarmLeads' | translate}}</span>
                    </div>
                </div>
            </div>
        </div>
    }
</section>

<section class="ft-section ft-person-activity-section" [hidden]="isLoading()">
    @if (advocate()) {
        <div class="ft-container">
            <!-- Photo contest -->
            @if (isPhotoContestAvailable()) {
                <div class="activity-story">
                    <div class="activity-heading">
                        {{'flipto.account.sections.platform.photoAdvocacy.PhotoContest' | translate}}: {{advocate().photoContest.variation.name}}
                    </div>
                    <div class="activity-timestamp">
                        {{advocate().photoContest.variation.epochStartDate | parse:'number' | dateFormat:'MMM D'}} - {{advocate().photoContest.variation.epochEndDate | parse:'number' | dateFormat:'MMM D'}}, {{advocate().photoContest.variation.epochEndDate | parse:'number' | dateFormat:'YYYY'}}
                    </div>
                    @if (advocate().photoContest.guestUrl || advocate().photoContest.friendUrl) {
                        <div class="activity-link">
                            @if (advocate().photoContest.guestUrl) {
                                <a [href]="advocate().photoContest.guestUrl" target="_blank">@if (advocate().first) {<span>{{advocate().first}}'s </span>}{{'flipto.account.sections.platform.photoAdvocacy.ContestPage' | translate}}</a>
                            }
                            |
                            @if (advocate().photoContest.friendUrl) {
                                <a [href]="advocate().photoContest.friendUrl" target="_blank">{{'flipto.account.sections.platform.photoAdvocacy.Friend' | translate}}'s {{'flipto.account.sections.platform.photoAdvocacy.ContestPage' | translate}}</a>
                            }
                        </div>
                    }
                    @if (!advocate().photoContest.guestUrl && !advocate().photoContest.friendUrl) {
                        <div class="activity-link unavailable">
                            {{'flipto.account.NotYetVisited' | translate}}
                        </div>
                    }
                    <div class="activity-group" [hidden]="!(advocate().photoContest.emailsSent.length > 0)">
                        <div class="activity-label">{{'flipto.account.NotifiedAsFinalist' | translate}}</div>
                        <div class="ft-panel static">
                            @for (email of advocate().photoContest.emailsSent; track email) {
                                @if (email.isInitialEmail == 1) {
                                    <p class="date activity-note">
                                        {{'flipto.account.EmailWasSentOn' | translate}} {{email.epochEmailSentDate | parse:'number' | dateFormat:'MMM D, YYYY'}}
                                    </p>
                                }
                                @if (email.isInitialEmail == 0) {
                                    <p class="date activity-note">
                                        {{'flipto.account.ReminderEmailWasSentOn' | translate}} {{email.epochEmailSentDate | parse:'number' | dateFormat:'MMM D, YYYY'}}
                                    </p>
                                }
                            }
                        </div>
                    </div>
                    @for (photo of advocate().photoContest.photos; track photo) {
                        <div class="activity-group">
                            <div class="activity-label">{{'flipto.account.Activity' | translate}}</div>
                            <div class="ft-panel photo-panel static">
                                <div class="activity-photo" [style.background-image]="photo.photoUrl ? 'url(' + photo.photoUrl + ')' : null"></div>
                                <div class="ft-row">
                                    <div class="ft-col-75">
                                        <div class="activity-photo-details">
                                            <p class="ft-heading" [hidden]="!(photo.score | parse:'number')">{{photo.score | parse:'number' | number}} {{'flipto.account.Points' | translate | uppercase}}</p>
                                            <div class="activity-note activity-contest-stats">
                                                <p [hidden]="!(photo.totalGuestShares | parse:'number')">{{'flipto.account.Shared' | translate}} {{photo.totalGuestShares | parse:'number' | number}} {{'flipto.account.Times' | translate | lowercase}}</p>
                                                <p [hidden]="!(photo.totalFriendVotes | parse:'number')">{{photo.totalFriendVotes | parse:'number' | number}} {{'flipto.account.FriendsVoted' | translate | lowercase}}</p>
                                                <p [hidden]="!(photo.totalFriendSignups | parse:'number')">{{photo.totalFriendSignups | parse:'number' | number}} {{'flipto.account.FriendsSignedUp' | translate | lowercase}}</p>
                                                <p [hidden]="!(photo.totalOtherShares | parse:'number')">{{photo.totalOtherShares | parse:'number' | number}} {{'flipto.account.FriendShares' | translate | lowercase}}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="activity-group" [hidden]="!(photo.promotions.length > 0)">
                            <div class="activity-label">{{'flipto.account.SharedVia' | translate}}</div>
                            <div class="ft-panel static">
                                @for (promotion of photo.promotions; track promotion) {
                                    <div class="activity-social"
                                         [ngClass]="{'facebook': promotion.title == 'fb', 'twitter': promotion.title == 'tw', 'linkedin': promotion.title == 'li', 'other': promotion.title == 'Others'}">
                                        <span class="count" [hidden]="!(promotion.totalFollowers | parse:'number')">{{promotion.totalFollowers | parse:'number' | number}}</span>
                                        <span class="count multiplier" [hidden]="!(promotion.totalFollowers | parse:'number')">x {{promotion.totalShareTimes | parse:'number' | number}}</span>
                                    </div>
                                }
                            </div>
                        </div>
                        <div class="activity-group" [hidden]="!(photo.friendPromotions.length > 0)">
                            <div class="activity-label">{{'flipto.account.FriendsShared' | translate}}</div>
                            <div class="ft-panel static">
                                @for (promotion of photo.friendPromotions; track promotion) {
                                    <div class="activity-social"
                                         [ngClass]="{'facebook': promotion.title == 'fb', 'twitter': promotion.title == 'tw', 'linkedin': promotion.title == 'li', 'other': promotion.title == 'Others'}">
                                        <span class="count multiplier" [hidden]="!(promotion.totalShareTimes | parse:'number')">x {{promotion.totalShareTimes | parse:'number' | number}}</span>
                                    </div>
                                }
                            </div>
                        </div>
                        <div class="activity-group" [hidden]="!photo.winner">
                            <div class="activity-label">{{'flipto.account.WonPrize' | translate}}</div>
                            @if (photo.winner) {
                                <div class="ft-panel static">
                                    <p class="ft-heading" [hidden]="photo.winner.winnerTypeId != 1">{{'flipto.account.sections.platform.photoAdvocacy.1stPlace' | translate}}</p>
                                    <p class="ft-heading" [hidden]="photo.winner.winnerTypeId != 2">{{'flipto.account.sections.platform.photoAdvocacy.2ndPlace' | translate}}</p>
                                    <p class="ft-heading" [hidden]="photo.winner.winnerTypeId != 3">{{'flipto.account.sections.platform.photoAdvocacy.3rdPlace' | translate}}</p>
                                    <p class="ft-heading" [hidden]="photo.winner.winnerTypeId != 100">{{'flipto.account.sections.platform.photoAdvocacy.RunnerUp' | translate}}</p>
                                    <p class="activity-note"><a [href]="photo.winner.voucherUrl" target="_blank">{{photo.winner.incentiveText}}</a></p>
                                    <p class="activity-note" [hidden]="!(photo.winner.isRedeemed | parse:'bool')">{{'flipto.account.Redeemed' | translate}} {{photo.winner.epochRedeemDate | parse:'number' | dateFormat:'MMM D, YYYY'}}</p>
                                    <p class="activity-note" [hidden]="(photo.winner.isRedeemed | parse:'bool')">
                                        @if ((photo.winner.isExpired | parse:'bool')) {
                                            <span>{{'flipto.account.Expired' | translate}}</span>
                                        }
                                        @if (!(photo.winner.isExpired | parse:'bool')) {
                                            <span>{{'flipto.account.Expires' | translate}}</span>
                                        }
                                        {{photo.winner.utcExpirationDate | dateFormat:'MMM D, YYYY'}} &nbsp;&nbsp;
                                        <a (click)="editCertificateExpirationDate(photo.winner)">{{'flipto.account.Edit' | translate}}</a>
                                    </p>
                                </div>
                            }
                        </div>
                    }
                </div>
            }

            <!-- Poststay -->
            @if (isPoststayAvailable()) {
                <div class="activity-story">
                    <div class="activity-heading">
                        {{(isInvitee() ? 'flipto.account.platform.ContestInvitation' : 'flipto.account.platform.PostStayAdvocacy') | translate}}
                    </div>
                    @if (advocate().poststay.epochDate) {
                        <div class="activity-timestamp">
                            {{'flipto.account.LastInteraction' | translate}}: {{advocate().poststay.epochDate | parse: 'number' | dateFormat: 'MMM D, YYYY'}}
                        </div>
                    }
                    <div class="activity-link">
                        <a [href]="advocate().poststay.reviewUrl" target="_blank">@if (advocate().first) {<span>{{advocate().first}}'s </span>}{{(isInvitee() ? 'flipto.account.InvitationProcess' : 'flipto.account.PoststayProcess') | translate}}</a>
                    </div>
                    <div class="activity-group" [hidden]="!(advocate().poststay.epochEmailClickDate || advocate().poststay.epochEmailViewDate || advocate().poststay.epochEmailSentDate)">
                        <div class="activity-label">{{'flipto.account.InvitedToPoststay' | translate}}</div>
                        <div class="ft-panel static">
                            <p class="ft-heading" [hidden]="!advocate().poststay.epochEmailClickDate">{{'flipto.account.EmailWasClicked' | translate}}</p>
                            <p class="ft-heading" [hidden]="!(!advocate().poststay.epochEmailClickDate && !!(advocate().poststay.epochEmailViewDate))">{{'flipto.account.EmailWasViewedButNotClicked' | translate}}</p>
                            <p class="ft-heading" [hidden]="!(!advocate().poststay.epochEmailClickDate && !advocate().poststay.epochEmailViewDate && !!(advocate().poststay.epochEmailSentDate))">{{'flipto.account.EmailWasNotViewed' | translate}}</p>
                            <p class="activity-note">{{(advocate().poststay.epochEmailClickDate || advocate().poststay.epochEmailViewDate || advocate().poststay.epochEmailSentDate) | parse:'number' | dateFormat: 'MMM D, YYYY'}}</p>
                        </div>
                    </div>
                    <div class="activity-group" [hidden]="!(advocate().poststay.epochReminderEmailClickDate || advocate().poststay.epochReminderEmailViewDate || advocate().poststay.epochReminderEmailSentDate)">
                        <div class="activity-label">{{'flipto.account.RemindedAboutPoststay' | translate}}</div>
                        <div class="ft-panel static">
                            <p class="ft-heading" [hidden]="!advocate().poststay.epochReminderEmailClickDate">{{'flipto.account.EmailWasClicked' | translate}}</p>
                            <p class="ft-heading" [hidden]="!(!advocate().poststay.epochReminderEmailClickDate && !!(advocate().poststay.epochReminderEmailViewDate))">{{'flipto.account.EmailWasViewedButNotClicked' | translate}}</p>
                            <p class="ft-heading" [hidden]="!(!advocate().poststay.epochReminderEmailClickDate && !advocate().poststay.epochReminderEmailViewDate && !!(advocate().poststay.epochReminderEmailSentDate))">{{'flipto.account.EmailWasNotViewed' | translate}}</p>
                            <p class="activity-note">{{(advocate().poststay.epochReminderEmailClickDate || advocate().poststay.epochReminderEmailViewDate || advocate().poststay.epochReminderEmailSentDate) | parse:'number' | dateFormat: 'MMM D, YYYY'}}</p>
                        </div>
                    </div>
                    <div class="activity-group" [hidden]="!(advocate().poststay.quote && (advocate().poststay.quote.rating | parse:'number':null) !== null)">
                        <div class="activity-label">{{'flipto.account.Rated' | translate}}</div>
                        @if (advocate().poststay.quote) {
                            <div class="ft-panel static">
                                <div class="ft-heading">
                                    <span class="activity-rating activity-rating-{{advocate().poststay.quote.rating}}">{{advocate().poststay.quote.rating}}</span> {{'flipto.account.OutOf' | translate}} 5
                                </div>
                            </div>
                        }
                    </div>
                    <div class="activity-group" [hidden]="!advocate().poststay.photo">
                        <div class="activity-label">{{'flipto.account.SubmittedPhoto' | translate}}</div>
                        @if (advocate().poststay.photo) {
                            <div class="ft-panel photo-panel static">
                                <div class="activity-photo" [style.background-image]="advocate().poststay.photo.photoUrl ? 'url(' + advocate().poststay.photo.photoUrl + ')' : null"></div>
                                <div class="ft-row">
                                    <div class="ft-col-75">
                                        <div class="activity-photo-details">
                                            <p class="ft-heading" [hidden]="!(advocate().poststay.photo.isFinalist | parse:'bool')">{{'flipto.account.AdvancedToFinals' | translate}}</p>
                                            <div class="activity-note">
                                                <span [hidden]="!advocate().poststay.photo.caption">{{advocate().poststay.photo.caption}}</span>
                                                <span [hidden]="!advocate().poststay.photo.location">{{advocate().poststay.photo.location}}
                                                    <span [hidden]="!(!!(advocate().poststay.photo.location) && !!(advocate().poststay.photo.date))">,</span> {{advocate().poststay.photo.date}}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="ft-col-25 action-container">
                                        <input type="button" value="Curate" class="ft-btn ft-btn-outline-dark" (click)="curateModal()" />
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                    <div class="activity-group" [hidden]="!(!!(advocate().poststay.quote?.notesPositive) || !!(advocate().poststay.quote?.notesNegative))">
                        @if (advocate().poststay.quote) {
                            <div class="activity-label" [hidden]="!(!!(advocate().poststay.quote.notesPositive))">{{'flipto.account.SubmittedQuote' | translate}}</div>
                            <div class="activity-label" [hidden]="!!(advocate().poststay.quote.notesNegative)">{{'flipto.account.GaveFeedback' | translate}}</div>
                            <div class="ft-panel static">
                                <div class="ft-row">
                                    <div class="ft-col-75">
                                        <p class="quote">
                                            &ldquo;{{advocate().poststay.quote.notesPositive}}&rdquo;
                                        </p>
                                    </div>
                                    <div class="ft-col-25 action-container">
                                        @if (!!(advocate().poststay.quote.notesPositive)) {
                                            <input type="button" value="Curate" class="ft-btn ft-btn-outline-dark" (click)="curateModal()" />
                                        }
                                    </div>
                                </div>
                            </div>
                            <div class="activity-label" [hidden]="!advocate().poststay.quote.notesNegative">{{'flipto.account.GaveFeedback' | translate}}</div>
                            <div class="ft-panel static" [hidden]="!advocate().poststay.quote.notesNegative">
                                <p class="feedback">
                                    &ldquo;{{advocate().poststay.quote.notesNegative}}&rdquo;
                                </p>
                            </div>
                        }
                    </div>
                    <div class="activity-group" [hidden]="!(advocate().poststay.promotions.length > 0)">
                        <div class="activity-label">{{'flipto.account.SharedVia' | translate}}</div>
                        <div class="ft-panel static">
                            @for (promotion of advocate().poststay.promotions; track promotion) {
                                <div class="activity-social"
                                     [ngClass]="{'facebook': promotion.title == 'fb', 'twitter': promotion.title == 'tw', 'linkedin': promotion.title == 'li', 'other': promotion.title == 'Others'}">
                                    <span class="count" [hidden]="!(promotion.totalFollowers | parse:'number')">{{promotion.totalFollowers | parse:'number'}}</span>
                                </div>
                            }
                        </div>
                    </div>
                    <div class="activity-group" [hidden]="!((advocate().poststay.totalVisitors | parse:'number') > 0 || (advocate().poststay.totalSignups | parse:'number') > 0)">
                        <div class="activity-label">{{'flipto.account.ResultingIn' | translate}}</div>
                        <div class="ft-panel static">
                            <div class="ft-heading">
                                {{advocate().poststay.totalVisitors | parse: 'number'}} {{'flipto.account.platform.UniqueVisitors' | translate}}, {{ advocate().poststay.totalSignups | parse: 'number' }} {{'flipto.account.platform.WarmLeads' | translate}}
                            </div>
                        </div>
                    </div>
                    <div class="activity-group" [hidden]="!(advocate().poststay.incentives.length > 0)">
                        <div class="activity-label">{{'flipto.account.EarnedIncentive' | translate}}</div>
                        <div class="multi-panel">
                            @for (incentive of advocate().poststay.incentives; track incentive) {
                                <div class="ft-panel static"
                                     [ngClass]="{'expired': !!(incentive.isExpired | parse:'bool') && !(incentive.isRedeemed | parse:'bool'), 'redeemed': !!(incentive.isRedeemed | parse:'bool')}">
                                    <div class="ft-row">
                                        <div class="ft-col-75">
                                            <div class="ft-heading">{{incentive.incentiveTypeId}}</div>
                                            <p>
                                                <a [href]="incentive.voucherUrl" target="_blank">{{incentive.incentiveText}}</a>
                                            </p>
                                            <p class="activity-note" [hidden]="!(incentive.isRedeemed | parse:'bool')">{{'flipto.account.Redeemed' | translate}} {{incentive.epochRedeemDate | parse:'number' | dateFormat:'MMM D, YYYY'}}</p>
                                            <p class="activity-note" [hidden]="(incentive.isRedeemed | parse:'bool')">
                                                @if ((incentive.isExpired | parse:'bool')) {
                                                    <span>{{'flipto.account.Expired' | translate}}</span>
                                                }
                                                @if (!(incentive.isExpired | parse:'bool')) {
                                                    <span>{{'flipto.account.Expires' | translate}}</span>
                                                }
                                                {{incentive.utcExpirationDate | dateFormat:'MMM D, YYYY'}} &nbsp;&nbsp;
                                                <a (click)="editCertificateExpirationDate(incentive)">{{'flipto.account.Edit' | translate}}</a>
                                            </p>
                                        </div>
                                        <div class="ft-col-25 action-container">
                                            @if (!(incentive.isRedeemed | parse:'bool')) {
                                                <input type="button" [value]="'flipto.account.ResendCertificate' | translate" class="ft-btn ft-btn-outline-dark" (click)="sendCertificate(incentive)" />
                                            }
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            }

            <!-- Hotel stay -->
            @if (isHotelStayAvailable()) {
                <div class="activity-story">
                    <div class="activity-heading">
                        {{'flipto.account.HotelStay' | translate}}
                    </div>
                    <div class="activity-timestamp">
                        {{advocate().epochStartDate | parse: 'number' | dateFormat: 'MMM D'}} - {{advocate().epochEndDate | parse: 'number' | dateFormat:'MMM D'}}, {{advocate().epochEndDate | parse: 'number' | dateFormat: 'YYYY'}}
                    </div>
                </div>
            }

            <!-- Prestay -->
            @if (isPrestayAvailable()) {
                <div class="activity-story">
                    <div class="activity-heading">
                        {{'flipto.account.platform.PreStayAdvocacy' | translate}}
                    </div>
                    @if (advocate().prestay.epochDate) {
                        <div class="activity-timestamp">
                            {{'flipto.account.LastInteraction' | translate}}: {{advocate().prestay.epochDate | parse: 'number' | dateFormat: 'MMM D, YYYY'}}
                        </div>
                    }
                    <div class="activity-link">
                        <a [href]="advocate().prestay.followupUrl" target="_blank">@if (advocate().first) {<span>{{advocate().first}}'s </span>}{{'flipto.account.SharePage' | translate}}</a>
                    </div>
                    <div class="activity-group" [hidden]="!(advocate().prestay.promotions.length > 0)">
                        <div class="activity-label">{{'flipto.account.SharedVia' | translate}}</div>
                        <div class="ft-panel static">
                            @for (promotion of advocate().prestay.promotions; track promotion) {
                                <div class="activity-social"
                                     [ngClass]="{'facebook': promotion.title == 'fb', 'twitter': promotion.title == 'tw', 'linkedin': promotion.title == 'li', 'other': promotion.title == 'Others'}">
                                    <span class="count" [hidden]="!(promotion.totalFollowers | parse:'number')">{{promotion.totalFollowers | parse:'number' | number}}</span>
                                </div>
                            }
                        </div>
                    </div>
                    <div class="activity-group" [hidden]="!((advocate().prestay.totalVisitors | parse:'number') > 0 || (advocate().prestay.totalSignups | parse:'number') > 0)">
                        <div class="activity-label">{{'flipto.account.ResultingIn' | translate}}</div>
                        <div class="ft-panel static">
                            <div class="ft-heading">
                                {{advocate().prestay.totalVisitors | parse: 'number'}} {{'flipto.account.platform.UniqueVisitors' | translate}}, {{ advocate().prestay.totalSignups | parse: 'number' }} {{'flipto.account.platform.WarmLeads' | translate}}
                            </div>
                        </div>
                    </div>
                    <div class="activity-group" [hidden]="!(advocate().prestay.incentives.length > 0)">
                        <div class="activity-label">{{'flipto.account.EarnedIncentive' | translate}}</div>
                        <div class="multi-panel">
                            @for (incentive of advocate().prestay.incentives; track incentive) {
                                <div class="ft-panel static"
                                     [ngClass]="{'expired': !!(incentive.isExpired | parse:'bool') && !(incentive.isRedeemed | parse:'bool'), 'redeemed': !!(incentive.isRedeemed | parse:'bool')}">
                                    <div class="ft-row">
                                        <div class="ft-col-75">
                                            <div class="ft-heading">{{incentive.incentiveTypeId}}</div>
                                            <p>
                                                <a [href]="incentive.voucherUrl" target="_blank">{{incentive.incentiveText}}</a>
                                            </p>
                                            <p class="activity-note" [hidden]="!(incentive.isRedeemed | parse:'bool')">{{'flipto.account.Redeemed' | translate}} {{incentive.epochRedeemDate | parse:'number' | dateFormat:'MMM D, YYYY'}}</p>
                                            <p class="activity-note" [hidden]="(incentive.isRedeemed | parse:'bool')">
                                                @if ((incentive.isExpired | parse:'bool')) {
                                                    <span>{{'flipto.account.Expired' | translate}}</span>
                                                }
                                                @if (!(incentive.isExpired | parse:'bool')) {
                                                    <span>{{'flipto.account.Expires' | translate}}</span>
                                                }
                                                {{incentive.utcExpirationDate | dateFormat:'MMM D, YYYY'}} &nbsp;&nbsp;
                                                <a (click)="editCertificateExpirationDate(incentive)">{{'flipto.account.Edit' | translate}}</a>
                                            </p>
                                        </div>
                                        <div class="ft-col-25 action-container">
                                            @if (!(incentive.isRedeemed | parse:'bool')) {
                                                <input type="button" [value]="'flipto.account.ResendCertificate' | translate" class="ft-btn ft-btn-outline-dark" (click)="sendCertificate(incentive)" />
                                            }
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            }

            <!-- Booked stay / Poststay click / Prearrival email view -->
            @if (advocate().logTypeId == 1 || advocate().logTypeId == 3 || advocate().logTypeId == 7) {
                <div class="activity-story">
                    @if (advocate().logTypeId == 1) {
                        <div class="activity-heading">
                            {{'flipto.account.BookedStay' | translate}}
                        </div>
                    }
                    @if (advocate().logTypeId == 3) {
                        <div class="activity-heading">
                            {{'flipto.account.PoststayClick' | translate}}
                        </div>
                    }
                    @if (advocate().logTypeId == 7) {
                        <div class="activity-heading">
                            {{'flipto.account.PrearrivalEmailView' | translate}}
                        </div>
                    }
                    <div class="activity-timestamp">{{advocate().epochDate | parse: 'number' | dateFormat: 'MMM D, YYYY'}}</div>
                </div>
            }
        </div>
    }
</section>

<!-- Inline sub-modals (edit certificate expiration, edit profile, cancel
     reservation) are AngularJS ftModal directives in the v1 template. They
     stay AngularJS for now — the unported ftModal wraps them via the parent
     account-v2 details.component shell. Once ftModal is upgraded (M5b/M6),
     port these inline. -->
